'use client';
import apartmentFilters from '@/app/dashboard/apartments/filters';
import { StatusBadge } from '@/components/ui/statusBadge';
import { cn } from '@/lib/cn';
import { toReadableAddress } from '@/lib/utils';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import { ApartmentConfig, type Apartment } from '@pigello/pigello-matrix';
import Dot from './dot';
import type { RelationFieldProps } from './types';

export const ApartmentItem: RelationFieldProps<Apartment> = {
  nested: getRelationFieldNames(ApartmentConfig),
  filters: apartmentFilters,
  renderItem: (item, isRelationField) => ({
    title: item.landlordCustomId ?? item?.apartmentId ?? item.customId,
    badge:
      item.status != null ? (
        <StatusBadge className='font-medium' status={item.status} />
      ) : undefined,
    descriptionItems: (
      <div
        className={cn(
          isRelationField ? 'grid w-full' : 'flex flex-row items-center'
        )}
      >
        <div className='font-medium'>
          {item.address
            ? toReadableAddress(item.address, true, false)
            : 'Ingen adress angiven'}
        </div>
        {!isRelationField && <Dot />}
        <div
          className={cn(
            'flex w-full items-center',
            isRelationField && 'justify-between'
          )}
        >
          <span>
            {ApartmentConfig.fields.category.choices?.find(
              (c) => c.v === item?.category
            )?.d ?? 'Ingen kategori angiven'}
          </span>
          {!isRelationField && <Dot />}
          <span>
            {item.landlordCustomId ??
              item.customId ??
              'Inget objekts-id angivet'}
          </span>
        </div>
      </div>
    ),
  }),
};
